class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      if(this.dataset.promoId && JSON.parse(this.dataset.autoAdd)) return;
      this.closest('cart-items').updateQuantity(this.dataset.index, 0, null, this.dataset.promoId);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.clearCartButton = document.getElementById('clear-cart-button');
    this.cartErrors = document.getElementById('cart-errors');
    this.cartObject = {};

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.addEventListener('click', this.handleClick.bind(this));

    this.addFirstInstanceClass();

    this.initialize();

    const self = this;
    document.addEventListener('cart:updated', function(event) {
      self.addFirstInstanceClass();
    }, false);
    document.addEventListener('ajaxProduct:added', function(event) {
      self.addFirstInstanceClass();
    }, false);
    document.addEventListener('cartdrawer:opened', function(event){
      self.addFirstInstanceClass();

      if(theme.shopSettings.restrictGuests && ! theme.shopSettings.activeCustomer) {
        self.clearCart();
      }
    }, false);
    this.querySelectorAll('promo-claim-button').forEach((button) => {
      button.addEventListener('click', function (event) {
        self.promoAddToCartClick(event.target);
      });
    });

    // Keep the cart item count updated after adding products
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      if(event.quantity) {
        self.currentItemCount += parseInt(event.quantity);
      };
    });

    if(this.clearCartButton) {
      this.clearCartButton.addEventListener('click', this.clearCart.bind(this));
    }
  }

  async initialize() {
    if (Shopify.pageType == 'cart') {
      //this.checkSavingsAmount();
      document.dispatchEvent(new CustomEvent('cart:loaded'));
    }
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  clearCart() {
    if(this.clearCartButton) {
      this.clearCartButton.parentElement.querySelector('.loading-overlay').classList.remove('hidden');
      this.clearCartButton.classList.add('hidden');
    }

    const sections = this.getSectionsToRender().map((section) => section.section),
          body = JSON.stringify({
            sections: sections,
            sections_url: window.location.pathname
          });
    
    fetch(`${theme.routes.cart_clear_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((state) => this.updateCart(state));
  }

  addFirstInstanceClass() {
    if(!document.querySelector('.bundle-parent-row')){
      const liElements = {
        elements: document.querySelectorAll('cart-items li[data-addid]'),
        type: 'mini-cart'
      };
      const trElements = {
        elements: document.querySelectorAll('cart-items tr.cart-item[data-addid]'),
        type: 'main-cart'
      };
      const elements = [liElements, trElements];
    
      for (let elementSet of elements) {
        const uniqueIds = new Set();
    
        if (elementSet.elements.length === 0) {
          continue;
        }
    
        for (let element of elementSet.elements) {
          const elType = elementSet.type === 'mini-cart' ? 'li' : 'tr';
          const elSubType = elementSet.type === 'mini-cart' ? 'span' : 'td';
          let addId = element.getAttribute('data-addid');
          if(addId && !uniqueIds.has(addId)) {
            uniqueIds.add(addId);
            element.classList.add('first-instance');
            const cartItemEl = `
              <${elType} class="bundle-parent-row">
                <${elSubType} ${elSubType === 'td' ? "colspan='2'" : ''} class="bundle-parent-title text-left"><span>${element.getAttribute('data-bundletitle')}</span></${elSubType}>
                <${elSubType} ${elSubType === 'td' ? "colspan='2'" : ''} class="bundle-parent-price-wrap">
                  <span class="bp-orig-price">
                    ${element.getAttribute('data-originalprice')}
                  </span>
                  <span class="bp-final-price">
                    ${element.getAttribute('data-bundleprice')}
                  </span>
                </${elSubType}>
                <${elSubType} ${elSubType === 'td' ? "colspan='2'" : ''} class="d-flex justify-content-end">
                  <a class="delete-product bundle-delete-button" data-bundleaddid="${element.getAttribute('data-addid')}">
                    <svg class="icon icon-close" aria-hidden="true" focusable="false">
                      <use href="#icon-close"></use>
                    </svg>
                  </a>
                </${elSubType}>
              </${elType}>
            `;
            element.insertAdjacentHTML('beforebegin', cartItemEl);
          }
        }
      }
    }
  }

  getTotalDiscountSavings() {
    if(Object.keys(this.cartObject).length === 0) {
      return;
    }
    let totalSavings = 0;
    this.cartObject.items.forEach(function(item){
      if(item.line_level_total_discount > 0){
        totalSavings += item.line_level_total_discount;
      }
    });
    return totalSavings / 100; //convert to dollars and return
  }

  checkSavingsAmount() {
    let totalDiscountSavings = this.getTotalDiscountSavings();
    const comparePriceTotal = parseFloat(document.querySelector('[data-compare-total]')?.dataset.compareTotal);
    const comparePriceSaving = parseFloat(document.querySelector('[data-compare-savings]')?.dataset.compareSavings);
    const compareSavings = comparePriceTotal - comparePriceSaving;
    if(totalDiscountSavings > 0 || compareSavings > 0){
      const cartSavingsRowEl = document.querySelector('.cart-savings');
      const cartSavingsEl = document.querySelector('.cart-savings-total');
      if(cartSavingsRowEl){
        cartSavingsRowEl.classList.remove('hidden');
      }
      if(cartSavingsEl){
        if(compareSavings > 0) {
          const compareSavingsDollars = compareSavings / 100;
          totalDiscountSavings += compareSavingsDollars;
        }
        cartSavingsEl.innerText = `$${totalDiscountSavings.toFixed(2).replace('.00', '')}`;
      }
    }
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];

    if(document.getElementById('quick-order-list')) {
      sections.push({
        id: 'quick-order-list',
        section: document.getElementById('quick-order-list').dataset.id,
        selector: '.js-contents'
      });
    }
    
    if(document.getElementById('mini-cart')) {
      sections.push({
        id: 'mini-cart',
        section: 'mini-cart',
        selector: ['.mini-cart__main', '.mini-cart__footer', 'milestone-tracker script'],
      });
    }

    if(document.getElementById('cart-icon-bubble')) {
      sections.push({
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      });
    }

    if(document.getElementById('mobile-cart-icon-bubble')) {
      sections.push({
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      });
    }

    if(document.getElementById('main-cart-header')) {
      sections.push({
        id: 'main-cart-header',
        section: document.getElementById('main-cart-header').dataset.id,
        selector: '.cart__header'
      });
    }

    return sections;
  }

  async removeBundleProductsFromCart(addId) {
    if( ! addId) return;

    const sections = this.getSectionsToRender().map((section) => section.section);

    let lineItemUpdates = {
      updates: [],
      sections: sections,
      sections_url: window.location.pathname
    };

    await fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        let cart = data;

        cart.items.forEach(function(item) {
          if(Object.hasOwn(item.properties, '__bundleaddid') && item.properties.__bundleaddid === parseInt(addId)){
            lineItemUpdates.updates.push(0)
          } else {
            lineItemUpdates.updates.push(item.quantity)
          }
        });
      });

    const body = JSON.stringify(lineItemUpdates);

    fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then(response => response.text())
      .then(state => {
        this.updateCart(JSON.parse(state));
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
      })
      .catch(error => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();

        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
          console.error(this.cartErrors); 
        }
      });
  }

  handleClick(event) {
    let targetElement = event.target;
    if (!targetElement.classList.contains('delete-product')) {
      targetElement = targetElement.closest('.delete-product');
    }
    if (targetElement && targetElement.getAttribute('data-bundleaddid')) {
      const addId = targetElement.getAttribute('data-bundleaddid');
      this.removeBundleProductsFromCart(addId);
    }
  }

  async updateQuantity(line, quantity, name, promoId) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    await fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        this.currentItemCount = state.item_count;

        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartHeader = document.getElementById('main-cart-header');
        if (cartHeader) cartHeader.classList.toggle('is-empty', parsedState.item_count === 0);

        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        
        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const replaceElements = (section, selector) => {
              const elementToReplace = element.querySelector(selector) || element;
    
              if (elementToReplace && parsedState.sections[section.section]) {
                elementToReplace.innerHTML =
                  this.getSectionInnerHTML(parsedState.sections[section.section], selector);
              }
            }

            // Update the entire mini cart if there are no items in the cart
            if(parsedState.item_count == 0) {
              section.selector = '.shopify-section';
            }

            if(typeof section.selector == 'object') {
              section.selector.forEach(s => {
                replaceElements(section, s);
              });
            } else {
              replaceElements(section, section.selector);
            }
          }
        }));
        
        this.updateQuantityLiveRegions(line, parsedState.item_count);
        
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });

        // The item removed was a gift
        // Store to local storage so we don't add this gift on the next resolve
        if(promoId && quantity == 0) {
          const giftsRemoved = JSON.parse(sessionStorage.getItem('promo:gifts_removed') || '[]');

          if(giftsRemoved.indexOf(promoId) < 0) {
            giftsRemoved.push(promoId);
          }
          sessionStorage.setItem('promo:gifts_removed', JSON.stringify(giftsRemoved));

          // Add a note to the cart / order
          const body = JSON.stringify({ note: `gifts removed: ${ giftsRemoved }` }),
                updateOptions = {...fetchConfig(), ...{ body }};

          fetch(`${theme.routes.cart_update_url}`, updateOptions);
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
    
    return true;
  }

  promoAddToCartClick(button) {
    const sections = this.getSectionsToRender().map((section) => section.section),
          data = button.dataset,
          body = JSON.stringify({
            id: data.variantId,
            quantity: 1,
            properties: {
              __gift: 'true',
              __promo_id: data.promoId,
              __auto_add: data.autoAdd
            },
            sections: sections,
            sections_url: window.location.pathname
          });

    button.closest('.cart__item--promo').querySelector('.loading-overlay').classList.remove('hidden');
    
    fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        
        // Update local storage and cart / order note
        let giftsRemoved = JSON.parse(sessionStorage.getItem('promo:gifts_removed') || '[]');
        giftsRemoved = giftsRemoved.filter(promoId => promoId != data.promoId);

        if(giftsRemoved.length > 0) {
          sessionStorage.setItem('promo:gifts_removed', JSON.stringify(giftsRemoved));
          
          const body = JSON.stringify({ note: `gifts removed: ${ giftsRemoved }` }),
                updateOptions = {...fetchConfig(), ...{ body }};

          fetch(`${theme.routes.cart_update_url}`, updateOptions);
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = theme.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    // const giftsInCart = this.querySelectorAll('.cart__item--promo').length;
    const loadingOverlay = this.querySelectorAll('.loading-overlay')[parseInt(line) - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      if (element) {
        const replaceElements = (section, selector) => {
          const elementToReplace = element.querySelector(selector) || element;

          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], selector);
          }
        }

        // Update the entire mini cart if there are no items in the cart
        if(parsedState.item_count == 0) {
          section.selector = '.shopify-section';
        }

        if(typeof section.selector == 'object') {
          section.selector.forEach(s => {
            replaceElements(section, s);
          });
        } else {
          replaceElements(section, section.selector);
        }
      }
    }));
  }

  updateCart(state) {
    this.classList.toggle('is-empty', state.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);

    this.renderContents(state);
    this.addFirstInstanceClass();
  }
}
customElements.define('cart-items', CartItems);

class PromoClaimButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(this.dataset.autoAdd == 'true' || this.dataset.autoAdd == true) {
      this.closest('cart-items').promoAddToCartClick(this);
    }
  }
}
customElements.define('promo-claim-button', PromoClaimButton);

class UpdateCartLineItem extends CartItems {
  constructor() {
    super();

    this.addEventListener('click', this.updateLineItem.bind(this));
  }

  async updateLineItem() {
    const lineItem = this.dataset.lineItem,
          isTrueAllianceOrder = this.getAttribute('data-is-true-alliance');

    this.querySelector('.label').classList.add('hidden');
    this.classList.add('loading', 'disabled');

    await super.updateQuantity(lineItem, this.dataset.quantity, null);
    
    const body = JSON.stringify({ note: null, attributes: { 'true-alliance-order': isTrueAllianceOrder }  });
    fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .finally(() => {
        document.location.href = '/checkout';
      });
  }
}
customElements.define('update-cart-line-item', UpdateCartLineItem);

class UpdateCartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.updateCartNote.bind(this));
  }

  async updateCartNote() {
    const note = this.getAttribute('data-note'),
          isTrueAllianceOrder = this.getAttribute('data-is-true-alliance');

    this.querySelector('.label').classList.add('hidden');
    this.classList.add('loading', 'disabled');

    const body = JSON.stringify({ note: note, attributes: { 'true-alliance-order': isTrueAllianceOrder } });
    await fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});

    if(document.location.href.indexOf('cart')) {
      document.location.href = '/checkout';
    } else {
      document.location.href = theme.routes.cart_url;
    }
  }
}
customElements.define('update-cart-note', UpdateCartNote);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);

class CartPromotions extends HTMLElement {
  constructor () {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    const productForm = this.querySelector('form');

    if( ! productForm) return;

    if(productForm.querySelector('[name="properties[__auto_add]"]')) {
      setTimeout(() => {
        productForm.submit();
      }, 2000);
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    const promoQuickViewButton = this.querySelector('promo-quick-view-button');

    if(promoQuickViewButton) {
      const body = JSON.stringify({ note: `promo dismissed: ${ promoQuickViewButton.getAttribute('data-id') }` }),
          updateOptions = {...fetchConfig(), ...{ body }};

      fetch(`${theme.routes.cart_update_url}`, updateOptions);
    }
  }
}

customElements.define('cart-promotions', CartPromotions);